
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-60 -40 120 80"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#E70013"}},[_c('path',{attrs:{"d":"M-60-40H60v80H-60z"}}),_c('circle',{attrs:{"fill":"#FFF","r":"20"}}),_c('circle',{attrs:{"r":"15"}}),_c('circle',{attrs:{"fill":"#FFF","cx":"4","r":"12"}}),_c('path',{attrs:{"d":"M-5 0l16.281-5.29L1.22 8.56V-8.56L11.28 5.29z"}})])])
          )
        }
      }
    